import { nodes } from "../common/reactHelpers.jsx";
import { esc, money } from "../../utils/format.js";
import { badge } from "../common/StatusBadge.jsx";

export function actionIcon(type) {
  const paths = {
    view: (
      <>
        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12Z"></path>

        <circle cx="12" cy="12" r="3"></circle>
      </>
    ),

    edit: <path d="m16 3 5 5-12 12-6 1 1-6Z M14 5l5 5"></path>,

    delete: (
      <path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"></path>
    ),
  };

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[type]}
    </svg>
  );
}

export function orderTable(rows, compact = false) {
  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Order</th>
            <th>Customer</th>
            {!compact && <th>Date</th>}
            <th>Total</th>
            <th>Payment</th>
            <th>Fulfilment</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {rows.length > 0 ? (
            nodes(
              rows.map((o) => (
                <tr key={o.id}>
                  <td>
                    <b>{esc(o.orderNumber)}</b>
                  </td>

                  <td>{esc(o.customerName || "Historical customer")}</td>

                  {!compact && (
                    <td>
                      {esc(
                        o.orderDate
                          ? new Date(o.orderDate).toLocaleDateString("en-IN")
                          : "—",
                      )}
                    </td>
                  )}

                  <td>{money(o.grandTotal ?? 0)}</td>

                  <td>{badge(o.paymentStatus || "Not available")}</td>

                  <td>
                    {badge(o.fulfillmentStatus || o.status || "Unfulfilled")}
                  </td>

                  <td>
                    <button
                      type="button"
                      className="table-action"
                      data-nav="order"
                      data-id={o.id}
                      title="View order"
                      aria-label="View order"
                    >
                      {actionIcon("view")}
                    </button>
                  </td>
                </tr>
              )),
            )
          ) : (
            <tr>
              <td colSpan={compact ? 6 : 7} className="empty">
                No matching orders.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
